module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TasksUse3-cdc9654a9a41cbef01d15be81e25f455.jpg";